export class Precificacao {
  produtoId = null;
  produtoInformacaoId = null;
  precoCompra = null;
  precoCusto = null;
  precoMedio = null;
  precoVenda = null;
  precoStandard = null;
  comissao = null;
  lucroDesejado = null;
  grupoTributacaoId = null;
  ncmCodigo = null;
  ncmId = null;
  cestId = null;
  aliquotas = null;

  constructor(precificacao) {
    this.produtoId = precificacao.produtoId;
    this.precoCompra = precificacao.precoCompra;
    this.precoCusto = precificacao.precoCusto;
    this.precoMedio = precificacao.precoMedio;
    this.precoVenda = precificacao.precoVenda;
    this.precoStandard = precificacao.precoStandard;
    this.comissao = precificacao.comissao;
    this.lucroDesejado = precificacao.lucroDesejado;
    this.grupoTributacaoId = precificacao.grupoTributacaoId;
    this.ncmCodigo = precificacao.ncmCodigo;
    this.ncmId = precificacao.ncmId;
    this.cestId = precificacao.cestId;
    this.produtoInformacaoId = precificacao.produtoInformacaoId;
    this.aliquotas = precificacao.aliquotas.map(
      (aliquota) => new Aliquota(aliquota)
    );
  }
}

class Aliquota {
  id = null;
  parametroAliquotaId = null;
  valor = null;

  constructor(dto) {
    this.id = dto.id;
    this.parametroAliquotaId = dto.parametroAliquotaId;
    this.valor = dto.valor;
  }
}
